import { Controller } from '@hotwired/stimulus';

// Attached by PaginationHelper#focused_row_attributes to the table row just saved, which the
// tab has already opened on the right page. Scrolls it into view - the table can sit far down
// a long tab - then trades `focus_row` in the URL for the table's plain page param, so a
// reload or paging another table keeps this table on its page without scrolling back here.
export default class extends Controller {
  connect() {
    // A cached preview connects this controller too, before the real page replaces it.
    if (document.documentElement.hasAttribute('data-turbo-preview')) return;

    // Turbo scrolls to the top once a visit has rendered, which is after this element
    // connects, so scrolling here would be undone (see pagination_controller.js).
    if (document.documentElement.hasAttribute('aria-busy')) {
      document.addEventListener('turbo:load', focusRow, { once: true });
    } else {
      focusRow();
    }
  }
}

// Looked up in the live document rather than through the connecting element, which may be
// gone by the time turbo:load fires.
function focusRow() {
  const row = document.querySelector('[data-controller~="focused-row"]');
  if (!row) return;

  row.scrollIntoView({ block: 'center' });
  pinPageInUrl(row);
}

// Each table renders its pagination control right after itself, so the row's control is the
// first one following it in the document.
function pinPageInUrl(row) {
  const control = Array.from(document.querySelectorAll('[data-controller~="pagination"]')).find(
    (el) => row.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING
  );
  const pageInput = control?.querySelector('[data-pagination-target="page"]');

  const url = new URL(window.location.href);
  url.searchParams.delete('focus_row');
  url.searchParams.delete('focus_type');
  if (pageInput) url.searchParams.set(control.dataset.paginationPageParamValue, pageInput.value);
  window.history.replaceState(window.history.state, '', url);
}
